import { SKS_MASTER_API_ENDPOINT } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { AuthenticateService } from '../../share/authenticate/authenticate.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MailchangeIf } from './mailchangeIf';
import { UtilService } from '../../share/util/util.service';

@Injectable()
export class MailchangeService {

  constructor(
    public http: HttpClient,
    public utilServ: UtilService,
    public authServ: AuthenticateService,
  ) { }

  public putMail(data: MailchangeIf.UpdModel): Observable<object> {
    const httpBody: MailchangeIf.UpdModel = {
      username: this.utilServ.uType.checkNull(data.username, 'string'),
      mail: this.utilServ.uType.checkNull(data.mail, 'string'),
    };
    Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());
    return this.http.request('put', `${SKS_MASTER_API_ENDPOINT}api/Employee/UpdMail`, { body: httpBody });
  }
}
